var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowse3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 62,
    viewBox: "0 0 49 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_6489)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_260_6489)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_260_6489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7696 46.9507V60.2882C47.7687 60.5872 47.6496 60.8738 47.4381 61.0851C47.2267 61.2966 46.9401 61.4158 46.6411 61.4167H1.5054C1.20639 61.4158 0.919885 61.2966 0.708457 61.0851C0.49703 60.8738 0.377868 60.5872 0.377005 60.2882V46.9507C0.370345 44.644 1.0094 42.3816 2.22186 40.4193C3.43432 38.4571 5.17178 36.8733 7.23764 35.8473L12.2816 33.3309H35.8649L40.9089 35.8473C42.9747 36.8733 44.7122 38.4571 45.9248 40.4193C47.1372 42.3816 47.7763 44.644 47.7696 46.9507Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0824 25.3083H19.0678C18.4446 25.3083 17.9395 25.8135 17.9395 26.4367V35.4638C17.9395 36.0869 18.4446 36.5921 19.0678 36.5921H29.0824C29.7055 36.5921 30.2107 36.0869 30.2107 35.4638V26.4367C30.2107 25.8135 29.7055 25.3083 29.0824 25.3083Z",
    fill: "#C8D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0341 11.6682C35.8307 8.63459 34.4822 5.79161 32.2617 3.71486C30.041 1.63812 27.1141 0.482788 24.0736 0.482788C21.0333 0.482788 18.1064 1.63812 15.8858 3.71486C13.6651 5.79161 12.3166 8.63459 12.1131 11.6682L11.776 16.6896C11.7618 16.9002 11.807 17.1107 11.9065 17.2969C12.0059 17.4833 12.1557 17.6379 12.3387 17.7433C12.5217 17.8487 12.7305 17.9006 12.9416 17.893C13.1526 17.8856 13.3573 17.8191 13.5324 17.7011C13.8129 17.5117 14.1434 17.41 14.4819 17.4094H15.0461C17.8021 17.4094 19.327 15.211 20.0688 13.6264C23.9156 16.2076 28.4694 17.5295 33.1004 17.4094H33.6646C34.0031 17.41 34.3339 17.5117 34.6144 17.7013C34.7896 17.8194 34.9942 17.886 35.2054 17.8934C35.4163 17.9008 35.6253 17.8489 35.8082 17.7434C35.9912 17.638 36.1409 17.4835 36.2405 17.2973C36.3399 17.1109 36.3851 16.9005 36.371 16.6898L36.0341 11.6682Z",
    fill: "#C40808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1732 15.1528H14.4806C13.4332 15.1528 12.4287 15.5689 11.688 16.3095C10.9473 17.0502 10.5312 18.0547 10.5312 19.1022C10.5312 20.1495 10.9473 21.1542 11.688 21.8948C12.4287 22.6355 13.4332 23.0514 14.4806 23.0514H16.1732C16.4725 23.0514 16.7595 22.9326 16.9711 22.721C17.1827 22.5095 17.3016 22.2223 17.3016 21.9231V16.2812C17.3016 15.9819 17.1827 15.6949 16.9711 15.4833C16.7595 15.2717 16.4725 15.1528 16.1732 15.1528Z",
    fill: "#C8D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6647 15.1528H31.9722C31.6729 15.1528 31.3859 15.2717 31.1742 15.4833C30.9626 15.6949 30.8438 15.9819 30.8438 16.2812V21.9231C30.8438 22.2223 30.9626 22.5095 31.1742 22.721C31.3859 22.9326 31.6729 23.0514 31.9722 23.0514H33.6647C34.7122 23.0514 35.7167 22.6355 36.4574 21.8948C37.198 21.1542 37.6141 20.1495 37.6141 19.1022C37.6141 18.0547 37.198 17.0502 36.4574 16.3095C35.7167 15.5689 34.7122 15.1528 33.6647 15.1528Z",
    fill: "#C8D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9617 11.4951C18.9856 11.5177 17.3334 15.206 15.0477 15.1511V20.4758C15.0169 22.8036 15.8659 25.0573 17.4249 26.7862C18.9839 28.515 21.1379 29.5919 23.4566 29.8011C24.6909 29.8845 25.9291 29.7135 27.0947 29.2987C28.2604 28.8838 29.3283 28.2342 30.2326 27.3898C31.1368 26.5454 31.8582 25.5243 32.3518 24.3898C32.8453 23.2553 33.1006 22.0316 33.102 20.7945V15.1571C28.1553 15.148 23.2911 13.8883 18.9617 11.4951Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7154 61.417L26.3303 43.3627L28.2147 38.6572L24.0735 36.5922L19.9324 38.6572L21.8167 43.3627L18.4316 61.417H29.7154Z",
    fill: "#EC7866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2139 38.6572L26.3296 43.3627H21.816L19.9316 38.6572L24.0728 36.5922L28.2139 38.6572Z",
    fill: "#EC7866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5341 49.0045V61.4169H8.27734V49.0045C8.27734 48.7053 8.39623 48.4182 8.60784 48.2067C8.81945 47.995 9.10647 47.8762 9.40574 47.8762C9.70501 47.8762 9.99202 47.995 10.2036 48.2067C10.4152 48.4182 10.5341 48.7053 10.5341 49.0045Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 49.0045V61.4169H37.6152V49.0045C37.6152 48.7053 37.734 48.4182 37.9457 48.2067C38.1574 47.995 38.4444 47.8762 38.7435 47.8762C39.0429 47.8762 39.3299 47.995 39.5415 48.2067C39.7532 48.4182 39.872 48.7053 39.872 49.0045Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0742 36.5923L29.1712 40.5224L35.8625 33.3255L30.5703 30.2088L24.0742 36.5923Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0735 36.5923L18.9765 40.5224L12.2852 33.3255L17.5774 30.2088L24.0735 36.5923Z",
    fill: "#E6ECFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_6489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.1448,
    height: 61.9005,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_260_6489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.1448,
    height: 61.9005,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_260_6489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.1448,
    height: 61.9005,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowse3);
export default __webpack_public_path__ + "static/media/browse3.dfb630efd0d0e6385c3a962da6000256.svg";
export { ForwardRef as ReactComponent };